export default {
  examList: []
}
